const STORAGE_PREFIX = 'monospace-studio';

/**
 * Namespaces a browser-storage key so Studio-owned entries in localStorage and sessionStorage
 * share one prefix. New keys should route through here.
 *
 *
 * @param name - The unprefixed key name
 * @returns The name prefixed with `monospace-studio:`
 *
 * @example
 * ```typescript
 * storageKey('last-login-method'); // returns "monospace-studio:last-login-method"
 * ```
 */
export function storageKey(name: string): string {
	return `${STORAGE_PREFIX}:${name}`;
}

/**
 * Like {@link storageKey}, but additionally scoped to a user id so two accounts sharing a browser
 * never read each other's entry.
 *
 * @param userId - The current user's id
 * @param name - The unprefixed key name
 * @returns The name prefixed with `monospace-studio:u:<userId>:`
 */
export function userStorageKey(userId: string, name: string): string {
	return storageKey(`u:${userId}:${name}`);
}
